import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import posed from 'react-pose'
import easing from 'ui/styles/easing'
import InViewMonitor from 'react-inview-monitor'

import Plus from './Plus'

const PosedAccordion = posed.div({
  closed: { height: 0 },
  open: { height: 'auto' }
})


const Wrapper = styled.div`
  background: white;
  margin-bottom: 25px;
  position: relative;
  padding-bottom: 104px;
  transform: ${props => props.inView ? 'translateY(0px)' : 'translateY(30px)'};
  opacity: ${props => props.inView ? 1 : 0};
  transition: transform 0.6s ${easing.easeOutCubic}, opacity 0.6s ${easing.easeOutCubic};
  
  &:hover {
    cursor: ${props => props.isAccordion ? 'pointer' : 'default'};
  }
`

const Image = styled.div`
  background-image: url(${props => props.image ? props.image : props.theme.colors.oxford.brush1});
  background-size: cover;
  background-position: center;
  background-color: ${props => props.theme.colors.oxford.base};
  height: 0;
  padding-bottom: 75%;
`

const Information = styled.div`
  padding: 25px 25px 5px 25px;
  position: absolute;
  bottom: 0;
  background: white;
  width: 100%;
`

const Name = styled.h2`
  color: ${props => props.theme.colors.oxford.base};
  margin: 0 0 3px;
  font-size: 28px;
  line-height: 31px;
`

const Text = styled.p`
  color: ${props => props.theme.colors.grey.darker};
  font-size: 18px;
  line-height: 22px;
`

const Position = styled(Text)`
  margin-bottom: 30px;
`

const Email = styled.a`
  border-bottom: 1px solid ${props => props.theme.colors.grey.base};
  color: ${props => props.theme.colors.grey.darker};
  padding-bottom: 0.5em;
  margin-bottom: 1em;
  display: block;
  transition: color 0.3s ${easing.easeOutCubic};
  font-size: 18px;

  &:hover {
    color: ${props => props.theme.colors.pacific.base};
  }
`

const Accordion = styled(PosedAccordion)`
  overflow: hidden;
`

export default class Employee extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired,
    image: PropTypes.string,
    email: PropTypes.string,
    text: PropTypes.string,
  }

  state = {
    active: false
  }

  triggerAccordion() {
    this.setState({active: !this.state.active})
  }
  
  render() {
    const {
      name,
      image,
      position,
      email,
      text
    } = this.props

    const { active } = this.state

    return(
      <InViewMonitor childPropsInView={{inView: true}}>
        <Wrapper
          onClick={() => this.triggerAccordion()}
          isAccordion={(email || text)}
          onMouseEnter={() => this.setState({active: true})}
          onMouseLeave={() => this.setState({active: false})}
        >
          <Image image={image ? image : null} />
          <Information>
            {(email || text) &&
              <Plus active={active} />
            }
            <Name>{name}</Name>
            <Position>{position}</Position>
            {(email || text) &&
              <Accordion pose={active ? 'open' : 'closed'}>
                <Email href={`mailto:${email}`}>{email}</Email>
                <Text>{text}</Text>
              </Accordion>
            }
          </Information>
        </Wrapper>
      </InViewMonitor>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Employees/Employee.js